import { Component } from 'preact'
import { connect } from 'preact-redux'
import cx from 'classnames'
import reachGoal from 'lib/reachGoal'

import { FormSubmitButton } from '../../form'

class NewPaybarSubmitButtonVacancy extends Component {
  constructor(props) {
    super(props)

    this.submit = this.submit.bind(this)
  }

  get goal() {
    return `${this.props.goalPrefix}_PAYBAR_${this.props.paybarGoalVersion}BUY`
  }

  get buttonText() {
    return I18n.t('newPaybar.submitButtonText.vacancy.subscribeAndPublish')
  }

  submit() {
    this.props.onSubmit()
    this.trackClick()
  }

  trackClick() {
    reachGoal(this.goal)
  }

  render(props) {
    const isButtonDisabled = !props.isValid || props.isLoading
    const className = cx('newPaybarSubmitButton', `is__${props.type}`)

    return (
      <span className="newPaybarSubmitButton-wrap">
        <FormSubmitButton
          className={ className }
          disabled={ isButtonDisabled }
          onClick={ this.submit }
          text={ this.buttonText } />
      </span>
    )
  }
}

const mapStateToProps = ({ newPaybar }) => {
  return {
    type: newPaybar.type,
    goalPrefix: newPaybar.goalPrefix,
    isLoading: newPaybar.isLoading,
    isValid: newPaybar.isValid,
    paybarGoalVersion: newPaybar.paybarGoalVersion,
  }
}

export default connect(mapStateToProps)(NewPaybarSubmitButtonVacancy)
